import { Search } from 'lucide-react'

import { CONTROLS } from '@brickup/shared/locales/de/controls'
import { FilterChipField } from '@/components/Internal/FilterChip'

/**
 * The search box, wherever Internal searches: a list's toolbar, a panel beside
 * an editor, a picker.
 */
export function SearchInput({
  value,
  onChange,
  placeholder,
  width = 'w-56',
  delayMs,
}: {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  /** The chip's width class. `w-full` where it fills a column. */
  width?: string
  /** What typing pauses before the parent hears it. `0` reports every
   *  keystroke, for a list filtered in the browser. */
  delayMs?: number
}) {
  return (
    <FilterChipField
      type="search"
      leading={<Search size={13} className="shrink-0 text-faint" aria-hidden />}
      value={value}
      onChange={onChange}
      placeholder={placeholder ?? CONTROLS.searchPlaceholder}
      width={width}
      delayMs={delayMs}
    />
  )
}
